import { createAsyncThunk } from "@reduxjs/toolkit";

import * as URL from "../../helpers/url_helper";

import { get, post, put, del } from "../../helpers/api_helper";

export const getFlagMessages = createAsyncThunk(
    "getFlagMessages",
    async ({ data, callback }, Thunk) => {
      try {
        let response = await post(URL.GET_FLAG_MESSAGE, data);
        callback && callback(null, response.data);
        return response;
      } catch (error) {
        callback && callback(error?.data?.message || error.message || error);
        return Thunk.rejectWithValue(error);
      }
    }
  );